export function queryShadowRoot(root, skipNode, isMatch, maxDepth = 600, depth = 0) {
    const matches = [];
    if (depth >= maxDepth || (root instanceof HTMLElement && skipNode(root))) {
        return matches;
    }
    const traverseSlot = ($slot) => {
        const assignedNodes = $slot.assignedNodes().filter((node) => node.nodeType === 1);
        if (assignedNodes.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const $slotParent = assignedNodes[0].parentElement;
            if ($slotParent.hasAttribute('has-focus-trap')) {
                const visibleAssignedNode = assignedNodes.filter((element) => element.getAttribute('tabindex') !== '-1');
                return queryShadowRoot(visibleAssignedNode[0], skipNode, isMatch, maxDepth, depth + 1);
            }
            return queryShadowRoot($slotParent, skipNode, isMatch, maxDepth, depth + 1);
        }
        return [];
    };
    const children = Array.from(root.children || []);
    if (root.tagName && root.tagName.includes('CIPUBLIC') && children.length === 0) {
        children.push(root);
    }
    for (const $child of children) {
        if (skipNode($child) && !$child.tagName.includes('CIPUBLIC')) {
            continue;
        }
        if (isMatch($child)) {
            matches.push($child);
        }
        if (!skipNode($child)) {
            if ($child.shadowRoot != null) {
                matches.push(...queryShadowRoot($child.shadowRoot, skipNode, isMatch, maxDepth, depth + 1));
            }
            else if ($child.tagName === 'SLOT') {
                matches.push(...traverseSlot($child));
            }
            else {
                matches.push(...queryShadowRoot($child, skipNode, isMatch, maxDepth, depth + 1));
            }
        }
    }
    const filteredMatches = matches.filter((c, index) => matches.indexOf(c) === index);
    return filteredMatches;
}
//# sourceMappingURL=search-tree.js.map